import { removeStorageData, setStorageData } from '@entities/common/savedData/reducer';
import { savedDataHashSelector } from '@entities/common/savedData/selectors';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@shared/hooks';

export const useSaveData = <DataType>(name: string) => {
  const savedDataHash = useAppSelector(savedDataHashSelector);
  const dispatch = useAppDispatch();

  const doSetStorageData = useCallback(
    (data: DataType) => dispatch(setStorageData({ name, data })),
    [dispatch, name]
  );

  const doRemoveStorageData = useCallback(
    () => dispatch(removeStorageData({ name })),
    [dispatch, name]
  );

  const data = savedDataHash[name] as DataType;

  return {
    data,
    doSetStorageData,
    doRemoveStorageData,
  };
};
